var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html } from 'lit';
import '../../avatar/sds-avatar.lit';
import { SdsLabelBase } from '../_sds-label-base.lit';
import styles from './sds-label-avatar.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-label-avatar` is a web component that combines an avatar with a label,
 * designed for visually representing users or entities.
 * It provides various attributes to customize the label's appearance and behavior.
 *
 * ### Attributes
 * - `name`: The name of this label.
 * - `role`: The role associated with this label, providing context.
 * - `description`: A description for the label.
 * - `icon`: The icon associated with the label.
 * - `src`: The source URL of the label's avatar image.
 * - `avatar-icon`: An alternative icon for the avatar.
 * - `action`: A boolean indicating if the label has an associated action. Defaults to `false`.
 * - `selected`: A boolean indicating if the label is selected. Defaults to `false`.
 * - `focused`: A boolean indicating if the label is focused. Defaults to `false`.
 * - `selectable`: A boolean indicating if the label can be selected. Defaults to `false`.
 * - `disabled`: A boolean indicating if the label is disabled. Defaults to `false`.
 * - `identifier`: An optional identifier for the label.
 *
 * @tag sds-label-avatar
 */
let SdsLabelAvatar = (() => {
    let _classDecorators = [sdsCustomElement('sds-label-avatar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsLabelBase;
    var SdsLabelAvatar = _classThis = class extends _classSuper {
        render() {
            return html ` ${this.renderLabelAvatar()} `;
        }
        renderLabelAvatar() {
            return html `
            <div
                class="${this.getClasses()}"
                @click="${(event) => this.handleClick(event)}"
                .disabled="${this.disabled}"
            >
                <sds-avatar
                    name="${this.name}"
                    role="${this.role}"
                    size="${this.size === 'lg' ? 'sm' : ''}"
                    icon="${this.avatarIcon}"
                    src="${this.src}"
                    .selected="${this.selected}"
                    .disabled="${this.disabled}"
                ></sds-avatar>
                ${this.renderButtonClose()}
            </div>
        `;
        }
        renderButtonClose() {
            if (this.action) {
                return html ` <sds-button
                type="secondary"
                size="sm"
                icon="close"
                rounded=""
                .disabled="${this.disabled}"
                @click="${this.handleClose}"
            ></sds-button>`;
            }
        }
    };
    __setFunctionName(_classThis, "SdsLabelAvatar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsLabelAvatar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsLabelAvatar = _classThis;
})();
export { SdsLabelAvatar };
